import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GridModule, RowFilterModule } from '@progress/kendo-angular-grid';
import { OpenEndedValidationPage } from './open-ended';
import { DirectivesModule } from '../../../directives/directives.module';
import { PtKendoModule } from '../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    OpenEndedValidationPage
  ],
  imports: [
    IonicPageModule.forChild(OpenEndedValidationPage),
    PtKendoModule,
    GridModule,
    RowFilterModule,
    DirectivesModule,
  ],
  providers: []
})
export class OpenEndedPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/validation/open-ended/open-ended.module.ts